














import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  layout: "authenticated",
  setup(): Record<string, unknown> {
    return {};
  },
});
